(self.webpackChunkthemekit_webpack = self.webpackChunkthemekit_webpack || []).push([
  [19],
  {
    913: () => {
      var e = document.querySelector(".announcement-bar-container").offsetHeight;
      document.querySelector("header"), document.querySelector("Main"), document.querySelector(".nav-icon");
      var t = document.getElementById("main-nav"),
        n = Array.from(document.querySelectorAll(".nav-item")),
        o = Array.from(document.querySelectorAll(".nav-content")),
        s = Array.from(document.querySelectorAll(".nav-hover"));
      function a(t) {
        var n = document.getElementById("nav-open-darken"),
          o = document.getElementById("MainContent"),
          s = document.querySelector("footer");
        (window.innerWidth || document.documentElement.clientWidth) >= 798 &&
          (n.classList.toggle("hidden", !t),
          o.classList.toggle("background-blur", t),
          s.classList.toggle("background-blur", t),
          n.classList.contains("announcementBar-enabled") &&
            (window.scrollY >= e ? (n.classList.remove("top-announcementBar_and_header"), n.classList.add("top-0")) : (n.classList.add("top-announcementBar_and_header"), n.classList.remove("top-0"))));
      }
      // Search functionality
      const searchIcon = document.querySelector(".search-icon-nav");
      const closeSearch = document.querySelector(".search-close-nav");
      const search = document.querySelector(".search");
      const mainHeaderBar = document.querySelector(".main-header-bar");
      const searchInput = document.querySelector(".search-bar__input");

      // Toggle .search visibility and optionally focus the input
      function toggleSearch(focusInput = false) {
        if (search.classList.contains("show")) {
            // Closing search
            search.classList.remove("show");
            setTimeout(() => search.classList.add("hidden"), 300); // Wait for animation to finish
        } else {
            // Opening search
            search.classList.remove("hidden");
            setTimeout(() => {
                search.classList.add("show");
                if (focusInput) {
                    setTimeout(() => searchInput.focus(), 50); // Ensure element is fully visible
                }
            }, 10); // Delay to ensure transition
        }
    }

      // Close .search if clicked outside .main-header-bar
      document.addEventListener("click", (event) => {
          if (!mainHeaderBar.contains(event.target)) search.classList.add("hidden");
      });

      // Event listeners for search actions
      [searchIcon, closeSearch].forEach((button, index) => {
          button.addEventListener("click", (event) => {
              event.stopPropagation(); // Prevent document click from triggering
              toggleSearch(index === 0); // Focus only for searchIcon
          });
      });

      // Add event listener for the Enter key to toggle search visibility when focused
      searchIcon.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
            event.preventDefault(); // Prevent the default action of 'Enter'
            toggleSearch(true); // Show search and focus the input
        }
      });

      // mobile menu animation
      document.getElementById('menu-toggle').addEventListener('click', function () {
        const button = this;
        const icon = button.querySelector('.material-symbols-rounded');
        if (icon.textContent === 'menu') {
            icon.textContent = 'close'; // Switch to 'close'
        } else {
            icon.textContent = 'menu'; // Switch back to 'menu'
        }
        button.classList.toggle('active'); // Trigger animation
      });
      
      // Toggles Mobile menu items
      function r() {
        var e = this.querySelector("button");
        e.classList.toggle("transform"), e.classList.toggle("rotate-90");
        var t = this.nextElementSibling;
        t.classList.contains("sub-item") ? t.classList.toggle("md-max:hidden") : (t.classList.toggle("md-max:hidden"), t.classList.toggle("flex-col"), t.classList.toggle("flex"));
      }

        document.addEventListener("click", function (e) {
          (e.target.closest(".nav-icon") || (t.classList.contains("menu-open") && !e.target.closest(".menu-open#main-nav > *"))) &&
            (function () {
              t.classList.toggle("md-max:opacity-0"),
                t.classList.toggle("md-max:invisible"),
                t.classList.toggle("md-max:h-0"),
                t.classList.toggle("md-max:h-0"),
                t.classList.toggle("md-max:w-0"),
                t.classList.toggle("flex"),
                t.classList.toggle("h-auto"),
                t.classList.toggle("w-full"),
                t.classList.toggle("menu-open");
              var e = document.getElementById("MainContent"),
                n = document.querySelector("body"),
                o = document.querySelector("footer");
                document.getElementById("nav-open-darken").classList.toggle("hidden"),
                e.classList.toggle("background-blur"),
                o.classList.toggle("background-blur"),
                n.classList.toggle("overflow-hidden");
            })();
        }),
        n.forEach(function (e) {
          e.addEventListener("click", r);
        }),
        s.forEach(function (t) {
          t.addEventListener("mouseenter", function () {
            window.scrollY <= e &&
              o.forEach(function (e) {
                e.classList.add("top-92");
              }),
              a(!0);
          }),
            t.addEventListener("mouseleave", function () {
              window.scrollY <= e &&
                o.forEach(function (e) {
                  e.classList.remove("top-92");
                }),
                a(!1);
            });
        });
    },
  },
  (e) => {
    e((e.s = 913));
  },
]);
